module.exports = __webpack_public_path__ + "img/maintanence_bg.71783675.jpg";